/*
 * Copyright (c) Dito Technologies
 */

import React from "react";
import {useParams} from "react-router-dom";
import ContentWrapper from "ui/common/ContentWrapper";
import {QueryRenderer} from "react-relay";
import environment from "constants/environment";
import query from "./PieceOriginalImagesQuery";
import ErrorSection from "ui/common/ErrorSection";
import LoadingSection from "ui/common/LoadingSection";
import {
    PieceOriginalImagesQuery
} from "ui/feature/piece-original-images/__generated__/PieceOriginalImagesQuery.graphql";
import PieceOriginalImagesBody from "ui/feature/piece-original-images/PieceOriginalImagesBody";
import Header1 from "ui/kit/typography/Header1";

const PieceOriginalImages: React.FC = () => {
    const params = useParams();
    const pieceId = params.piece_id;
    return (<ContentWrapper>
        <Header1>Original Images</Header1>
        <QueryRenderer<PieceOriginalImagesQuery>
            environment={environment} query={query} variables={{piece_id: pieceId ?? ""}} render={({error, props}) => {
            if (error) {
                return <ErrorSection/>;
            } else if (props) {
                return <PieceOriginalImagesBody piece={props.music_viewer.piece}/>;
            } else {
                return <LoadingSection/>
            }
        }}/>
    </ContentWrapper>);

}

export default PieceOriginalImages;